module.exports = __webpack_public_path__ + "img/trial2-4.cf8a657f.png";